export default "__VITE_ASSET__CCf4R0Ty__"